import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EmailService } from '@app/services/Email/email.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {
  enquiryForm!: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private emailService: EmailService){ }

  ngOnInit() {
    this.enquiryForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', Validators.compose([Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$')])],
      phone: ['', Validators.required],
      address: [''],
      message: ['', Validators.compose([Validators.required])],
    }) 
  } 
 
  get name() { return this.enquiryForm.controls['name']; }
  get email() { return this.enquiryForm.controls['email']; }
  get phone() { return this.enquiryForm.controls['phone']; }
  get address() { return this.enquiryForm.controls['address']; }
  get message() { return this.enquiryForm.controls['message']; }

  onSubmit() {
    if (this.enquiryForm.invalid) {
      Swal.fire("Please fill the form.");
      return;
    }
    
    const { name, email, phone, address, message} = this.enquiryForm.value;
    this.emailService.sendContactEmail(name, email, phone, address, message).subscribe({
      next: (response: any) => {
        this.enquiryForm.reset();
        if (response) {
          Swal.fire("Thanks for filling out our form! We will look over your message and get back to you within first 48 hours.")
        }
      },
      error: (error: any) => {
        Swal.fire("Technical Issue")
      }
    });
  }
}